import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

interface Request {
  modelId: Uuid;
  version: number;
}

export const deletePromptModel = async ({
  modelId,
}: Request): Promise<undefined> => {
  return sylvanus.remove(`/model/${modelId}`);
};
